import { createContext, useContext } from 'react'
import { useRouter } from 'next/router'

import { User } from '@shared-types/domain'

export const LoggedInUserContext = createContext<User | undefined>(undefined)
export const useLoggedInUser = (): User => {
  const user = useContext(LoggedInUserContext)
  const router = useRouter()
  // We should already have handled redirecting unauthenticated users at a higher level, but this is a safeguard to prevent errors in case of misuse of the context
  if (!user) {
    if (typeof window !== 'undefined') {
      void router.replace('/404')
    }
    // Optionally, throw to prevent further execution in SSR
    throw new Error('User not found')
  }
  return user
}
